import { lazy, useRef } from "react";
import { Box, Button, Paper, TextField } from "@mui/material";

import { useNavigate } from "react-router-dom";
import classes from "./AdminPanel.module.css";

import AreYouSureButton from "src/components/buttons/AreYouSureButton/AreYouSureButton";
import LazyLoader from "src/components/layout/Progress/LazyLoader";

const PersonSelectorAutocomplete = lazy(() =>
  import("src/components/person/PersonList/PersonSelectorAutocomplete")
);

export default function AdminPanel() {
  const navigate = useNavigate();
  const keikkaNoRef = useRef(null);
  const nappiKlik = async () => {};
  const setPerson = (person) => {
    console.log(person);
  };
  const onClick = () => {};

  return (
    <>
      <Paper elevation={2}>
        <AreYouSureButton
          onClick={onClick}
          dialogProps={{
            title: "Oletko varma?",
            content: "Oletko varma?",
            acceptText: "Olen varma",
          }}
          helpId="test">
          NAPPINAPPI
        </AreYouSureButton>
        <div className="center">
          <LazyLoader>
            <PersonSelectorAutocomplete setPerson={setPerson} />
          </LazyLoader>
        </div>
        <Button
          variant="outlined"
          onClick={() => {
            navigate("/admin/asiakas/0");
          }}>
          asiakasAdmin
        </Button>
        <Button
          variant="outlined"
          onClick={() => {
            navigate("/admin/hinta");
          }}>
          betoniAdmin
        </Button>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
          }}>
          <TextField inputRef={keikkaNoRef} defaultValue={"kirjoita keikkaId"} />

          <Button variant="outlined" onClick={nappiKlik} aria-label="Löydä betonitoimittaja">
            findBetoniToimittaja
          </Button>
          <br />
          <div className={classes.bar}>
            betoni.online saapuva tilaus: <b>B28/40m</b> keroinmäentie 88 nummela testiiiiii1 15m3
            Lattiabetoni hieno 16mm C30/37 S2 XC1 50v Muokkaa, hyväksy tai hylkää tilaus osoitteessa
            https://betoni.online/keikka/380{" "}
          </div>
        </Box>
      </Paper>
    </>
  );
}
